// Hook modyfikacji kalkulacji (nazwa/opis) -
// PUT /sales-crm/clients/:cid/offers/:oid/calculations/:calcId

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPutSalesCrmOfferCalculationPayload {
  name?: string;
  description?: string;
}

export type IPutSalesCrmOfferCalculationResponse = ICommandResponseSuccess & {
  id?: number;
};

const putSalesCrmOfferCalculation = (
  clientId: number,
  offerId: string,
  calculationId: number,
  payload: IPutSalesCrmOfferCalculationPayload
): Promise<IPutSalesCrmOfferCalculationResponse> =>
  axios.put(
    `/sales-crm/clients/${clientId}/offers/${offerId}/calculations/${calculationId}`,
    payload
  );

export const usePutSalesCrmOfferCalculation = (
  clientId: number,
  offerId: string,
  calculationId: number,
  options?: UseMutationOptions<
    IPutSalesCrmOfferCalculationResponse,
    IError,
    IPutSalesCrmOfferCalculationPayload
  >
) =>
  useMutation(
    (payload: IPutSalesCrmOfferCalculationPayload) =>
      putSalesCrmOfferCalculation(clientId, offerId, calculationId, payload),
    options
  );
